import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcSpinnerComponent } from './spinner.component';

@NgModule({
  declarations: [AcSpinnerComponent],
  exports: [AcSpinnerComponent],
  imports: [CommonModule],
})
export class AcSpinnerModule {}
